import Multilingual from '~~utils/Multilingual';

const localMapping = {
  SIDEBAR: {
    BASIC: {
      'zh-TW': '賽事資訊',
      en: 'Info',
    },
    PLUGINS: {
      'zh-TW': '擴充套件',
      en: 'Plugins',
    },
  },
  CREATE_TOURNAMENT: {
    'zh-TW': '新建賽事',
    en: 'Create Tournament',
  },
  CURRENT_PLAN: {
    'zh-TW': '目前方案',
    en: 'Current Plan',
  },
  PLAN_BASIC: {
    'zh-TW': '基本設定',
    en: 'Basic Setting',
  },
  PLAN_TOTAL: {
    'zh-TW': '總計',
    en: 'Total',
  },
  BASIC_NOT_COMPLETE: {
    'zh-TW': '賽事資訊不完整',
    en: 'Info is not completed',
  },
  CONTACT: {
    WORDING: {
      'zh-TW': '如何聯絡您',
      en: 'Who to Contact You',
    },
    NAME: {
      'zh-TW': '大名',
      en: 'Your Name',
    },
    PHONE: {
      'zh-TW': '電話（擇一）',
      en: 'Phone(Choose One)',
    },
    LINEID: {
      'zh-TW': 'LineID（擇一）',
      en: 'LineID(Choose One)',
    },
    ERROR: {
      'zh-TW': '聯絡資訊不完整',
      en: 'Contact is not completed',
    },
  },
};

const multi = (textCode, lang = '') => {
  return Multilingual(textCode, localMapping, lang);
};
export default multi;
